/* @flow */

import * as React from 'react';

import {TrialGatheringPreparing} from 'shells/trial-gathering/trial-gathering-preparing';

import {isMobileSignup, login} from '../../utils';

type Props = {|
    pills: string[],
    isProvisioningComplete: boolean,
    errorProvisioning: boolean,
    email: string,
    signupToken: string,
    formValues: Object,
    instanceId: string,
    emailSha1: string,
|};

export function TrialGatheringPreparingPage(props: Props) {
    const [hasCompletedLogin, setHasCompletedLogin] = React.useState<boolean>(false);
    const [progress, setProgress] = React.useState<number>(0.1);

    React.useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                const newProgress = prevProgress + 0.02;

                return newProgress > 0.95 ? 0.95 : newProgress;
            });
        }, 100);

        return () => clearInterval(interval);
    }, []);

    React.useEffect(() => {
        if (props.isProvisioningComplete && progress >= 0.9 && !hasCompletedLogin) {
            setHasCompletedLogin(true);

            // trigger analytics event (which go on to google tag manager (gtm), segment, etc)
            Analytics.trialSignupComplete(
                props.email,
                props.formValues,
                props.instanceId,
                props.emailSha1
            );

            if (isMobileSignup()) {
                login(props.email, props.signupToken);
            } else {
                fetch('/auth/signup-login', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        type: 7 /* User_Token::TYPE_INITIAL_LOGIN */,
                        token: props.signupToken,
                        username: props.email,
                        signupFormValues: props.formValues,
                    }),
                })
                    .then((response) => response.json())
                    .then((json) => {
                        if (json.success === true) {
                            // wait 500 ms to give GTM + Segment time to send the event
                            setTimeout(() => {
                                window.location = '/explore';
                            }, 500);
                        }
                    });
            }
        }
    }, [
        props.isProvisioningComplete,
        progress,
        props.email,
        props.signupToken,
        props.formValues,
        props.instanceId,
        props.emailSha1,
        hasCompletedLogin,
    ]);

    return (
        <TrialGatheringPreparing
            pills={props.pills}
            progress={progress}
            errorProvisioning={props.errorProvisioning}
        />
    );
}
